export default __webpack_public_path__ + "static/media/dashboardMobile.b0c0c00a.webp";